import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function CloseIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 32 32">
      <path
        d="M16 17.867 9.467 24.4q-.367.367-.934.367-.566 0-.933-.367t-.367-.933q0-.568.367-.934L14.133 16 7.6 9.467q-.367-.367-.367-.934 0-.566.367-.933t.933-.367.934.367L16 14.133 22.533 7.6q.367-.367.934-.367.566 0 .933.367t.367.933-.367.934L17.867 16l6.533 6.533q.367.367.367.934 0 .566-.367.933t-.933.367q-.568 0-.934-.367z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
